import styles from './ViewAllButton.module.css';

/** "View all →" link shared across every dashboard card's action slot. */
export function ViewAllButton({
  label,
  onClick,
  count,
}: {
  label: string;
  onClick: () => void;
  count?: number;
}) {
  return (
    <button type="button" onClick={onClick} className={styles.viewAllBtn}>
      {label}
      {count != null && ` (${count})`} →
    </button>
  );
}
